/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommentingConfig, fetchCommentingConfigV2 } from 'state/thunks/commenting';
import { PRODUCT_COMMENTING, PRODUCT_COMMENTING_V2 } from '../../../../state/thunks/account';
// utils
import { url } from '../../../../utils/urls';
// material
import { Page, Content, Link, Button, EmptyState, history } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import SiteFilter from '../../../../material/sitefilter/sitefilter';
import Loading from '../../../../material/states/loading/loading';

// content
import ImportComments from './importcomments/importcomments';
// styles
import injectSheet from "react-jss";
import styles from './commentimportertool_styles';

/* ========== ~~~~~~~~~~ COMMENT IMPORTER PAGE ~~~~~~~~~~ ========== */
const CommentImporterTool = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const { accountProducts } = useSelector(state => state.account) 
  const { commentingConfig } = useSelector(state => state.commenting)
  const { commentingUnitId } = useSelector(state => state.commentingV2.commentingUnitConfig)
  const { accountUUID, siteUUID } = useSelector((state) => state.session)
  const { sites } = useSelector(state => state.account) 
  const hasCommentingAccess = accountProducts?.includes(PRODUCT_COMMENTING);
  const hasCommentingV2Access = accountProducts?.includes(PRODUCT_COMMENTING_V2)
  const [isLoading,setIsLoading] = useState(true)

  useEffect(() => {
    if(accountUUID && siteUUID) loadCommentingConfig()
  }, [accountUUID, siteUUID]) 

  const loadCommentingConfig = useCallback(async()=>{
    if(hasCommentingV2Access) {
      const response = await dispatch(fetchCommentingConfigV2({ siteUUID }))
    } else {
      const response = await dispatch(fetchCommentingConfig({accountUUID, siteUUID, siteURL: sites[siteUUID] }))
    }
    setIsLoading(false)
  }, [siteUUID, accountUUID])

  const goToDocumentation = () => window.open('https://documentation.insticator.com/docs/data-management')

  const integrationId = useMemo(() => {
    return hasCommentingV2Access ? commentingUnitId : commentingConfig?.data?.commentingUnitUUID || null 
  }, [hasCommentingV2Access, commentingUnitId, commentingConfig?.data?.commentingUnitUUID])

  return (
    <Page name={'importertool'} klass={`${props.classes.commentimportertool}`}>
      <SiteFilter />
      <Content>
        <PageHeader 
          title={'Import Data'}  
          actionButton={<Button name={'docubtn'} icon={'book'} text={'Documentation'} variant={'system'} handleClick={goToDocumentation} />}
        />
        <PageContent>
          { isLoading || commentingConfig.status === 'pending' ?
            <Loading />
            :
            <>
            { hasCommentingAccess || hasCommentingV2Access ? 
              <ImportComments integrationId={integrationId} />
              :
              <EmptyState 
                graphicName={'error-404'} 
                buttonText={'Go to Request Commenting Unit Page'} 
                buttonClick={() => history.push('/dashboard/commenting/requestaccess')} 
                bodycopy={<p>Commenting is not yet enabled. Request access to enable importer tool.</p>} 
              />
            }
            </>
          }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentImporterTool;